import { Box, styled } from '@mui/material';
import OnboardingDashboardBackground from '../../../../assets/icons/onboarding/OnboardingDashboardBackground.svg';

export const OnboardingDashboardBackgroundImage = styled(Box)(() => ({
  position: 'absolute',
  zIndex: -1,
  right: -20,
  top: -120,
  width: '80%',
  height: '100%',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  backgroundImage: `url(${OnboardingDashboardBackground})`,
}));

export const OnboardingDashboardContainer = styled(Box)(({ theme }) => ({
  height: '100vh',
  width: '100%',
  display: 'flex',
  gap: theme.spacing(2),
  margin: '0',
  position: 'relative',
  [theme.breakpoints.down(1000)]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export const EmployeeContainer = styled(Box)(() => ({
  marginLeft: '5px',
  borderRadius: '10px',
  width: '30%',
  maxWidth: '600px',
  height: '380px',
}));
